import React from 'react';
import TaskStatistics from '../../components/admin/TaskStatistics';

export default function Numbers() {
  return (
    <div className="h-full">
      <TaskStatistics />
    </div>
  );
}
